import { render } from "./DeleteMillsModal.vue?vue&type=template&id=8150194e&scoped=true"
import script from "./DeleteMillsModal.vue?vue&type=script&lang=js"
export * from "./DeleteMillsModal.vue?vue&type=script&lang=js"

import "./DeleteMillsModal.vue?vue&type=style&index=0&id=8150194e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8150194e"]])

export default __exports__